var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H11.0909V11.0909H2V2ZM3.81818 3.81818V9.27273H9.27273V3.81818H3.81818Z",
    fill: "#1C1356"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63672 5.63635H7.4549V7.45453H5.63672V5.63635Z",
    fill: "#1C1356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9082 2H21.9991V11.0909H12.9082V2ZM14.7264 3.81818V9.27273H20.1809V3.81818H14.7264Z",
    fill: "#1C1356"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5449 5.63635H18.3631V7.45453H16.5449V5.63635Z",
    fill: "#1C1356"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.9091H11.0909V22H2V12.9091ZM3.81818 14.7272V20.1818H9.27273V14.7272H3.81818Z",
    fill: "#1C1356"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63672 16.5454H7.4549V18.3636H5.63672V16.5454Z",
    fill: "#1C1356"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9991 18.3636H18.3627V22H12.9082V12.9091V18.3636H14.7264V20.1818H16.5446V14.7272H14.7264V12.9091H13.8173H16.5446V14.7272H18.3627V16.5454H20.1809V12.9091H21.9991V18.3636ZM21.9991 20.1818V22H20.1809V20.1818H21.9991Z",
    fill: "#1C1356"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.c24b94e3.svg";
export { ForwardRef as ReactComponent };